// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .selected-row {\n  background: rgb(232, 232, 247);\n}\n.map__outer {\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n}\n#map {\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n  /* width: 100vw; */\n  /* height: 100vh; */\n  /* aspect-ratio: 1 / 1; */\n  min-height: 400px;\n  max-height: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
